import React, { useState, useEffect } from 'react';
import { getOptimizedImageUrl } from '../utils/imageHelper';

type ImageSize = 200 | 400 | 800 | 1200 | 1920;

interface OptimizedImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
    src: string | undefined | null;
    size: ImageSize;
    fallbackSrc?: string;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({ src, size, fallbackSrc, ...props }) => {
    const optimizedSrc = getOptimizedImageUrl(src, size);
    const [currentSrc, setCurrentSrc] = useState(optimizedSrc);
    
    useEffect(() => {
        // Reset state when the src or size prop changes
        setCurrentSrc(getOptimizedImageUrl(src, size));
    }, [src, size]);

    const handleError = () => {
        // If the optimized URL fails, try the original src URL.
        if (currentSrc === optimizedSrc && src) {
            setCurrentSrc(src);
        } else {
            // If the original src also fails (or if there's no original), use the fallback.
            setCurrentSrc(fallbackSrc);
        }
    };

    const finalSrc = currentSrc || fallbackSrc || `https://via.placeholder.com/${size}x${size}?text=Image+Not+Found`;

    return <img src={finalSrc} onError={handleError} {...props} />;
};

export default OptimizedImage;